/**
 *  DatabaseType values used by core to define the type of database.
 *  Has no relevance to the values written / read from the database.
 */

export enum DatabaseType {
  POSTGRESQL = 'POSTGRES',
  MYSQL = 'MYSQL',
  MARIADB = 'MARIADB',
  MSSQL = 'MSSQL',
  ORACLE = 'ORACLE',
  SQLITE = 'SQLITE'
}

/**
 * Should match the values in jdbcdrivers.name in the database
 */
export enum DatabaseDriverName {
  POSTGRESQL = 'PostgreSQL',
  MYSQL = 'MySQL',
  MARIADB = 'MariaDB',
  MSSQL = 'Microsoft SQLServer',
  ORACLE = 'Oracle',
  SQLITE = 'SQLite'
}
/*
 * Should match the values in jdbcdrivers.dbType in the database
 */
export enum DatabaseDriverEnum {
  POSTGRESQL = 'POSTGRES',
  MYSQL = 'MYSQL',
  MSSQL = 'MSSQL',
  ORACLE = 'ORACLE',
  SQLITE = 'SQLITE'
}

export const DatabaseTypeNameMapping: Record<DatabaseType, DatabaseDriverName> = {
  [DatabaseType.POSTGRESQL]: DatabaseDriverName.POSTGRESQL,
  [DatabaseType.MYSQL]: DatabaseDriverName.MYSQL,
  [DatabaseType.MARIADB]: DatabaseDriverName.MARIADB,
  [DatabaseType.MSSQL]: DatabaseDriverName.MSSQL,
  [DatabaseType.ORACLE]: DatabaseDriverName.ORACLE,
  [DatabaseType.SQLITE]: DatabaseDriverName.SQLITE
}

export enum TransactionIsolationLevel {
  Default = 'DEFAULT',
  ReadUncommitted = 'READ UNCOMMITTED',
  ReadCommitted = 'READ COMMITTED',
  RepeatableRead = 'REPEATABLE READ',
  Serializable = 'SERIALIZABLE'
}

export enum FailoverMode {
  Standard = 'STANDARD',
  Sticky = 'STICKY'
}

export enum Translator {
  MySQL = 'MYSQL',
  MSSQL = 'MSSQL',
  Oracle = 'ORACLE',
  Postgres = 'POSTGRES',
  SQLite = 'SQLITE'
}

export interface DatabaseDefaults {
  port: number
  host: string
  database: string
}

const DATABASE_DEFAULTS_BY_KEY: Record<keyof typeof DatabaseType, DatabaseDefaults> = {
  POSTGRESQL: {
    port: 5432,
    host: 'localhost',
    database: 'postgres'
  },
  MYSQL: {
    port: 3306,
    host: 'localhost',
    database: 'mysql'
  },
  MARIADB: {
    port: 3306,
    host: 'localhost',
    database: 'mysql'
  },
  MSSQL: {
    port: 1433,
    host: 'localhost',
    database: 'master'
  },
  ORACLE: {
    port: 1521,
    host: 'localhost',
    database: 'XE'
  },
  SQLITE: {
    port: 0, // SQLite doesn't use ports
    host: '',
    database: ':memory:'
  }
}

export const DATABASE_DEFAULTS = new Proxy({} as Record<DatabaseType, DatabaseDefaults>, {
  get(_target, prop: string | symbol) {
    // Find the enum key that corresponds to this value
    for (const [key, value] of Object.entries(DatabaseType)) {
      if (value === prop) {
        return DATABASE_DEFAULTS_BY_KEY[key as keyof typeof DatabaseType]
      }
    }
    return undefined
  }
})

export const DatabaseConstants = {
  DatabaseType,
  TransactionIsolationLevel,
  FailoverMode,
  Translator,
  DATABASE_DEFAULTS
} as const

export default DatabaseConstants
